import { Component, Input, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'event-analytics-attendees-chart',
	templateUrl: './EventAnalyticsAttendeesChart.Component.html',
	host: {
		class: 'width-full height-full',
		layout: 'column',
		'layout-wrap': 'false'
	}
})
export class EventAnalyticsAttendeesChartComponent {
	@Input() public data: any;

	private translatedStrings: { [key: string]: string };
	public status: { [key: string]: boolean };

	constructor(
		TranslateService: TranslateService
	) {
		this.translatedStrings = {
			attendees: TranslateService.instant('Attendees'),
			total: TranslateService.instant('Total')
		};

	}

	public ngOnChanges(changes: SimpleChanges) {
		if (changes.data) {
			this.status = { isLoading: true };
			setTimeout(() => this.status = { active: true }, 200);
		}
	}
}
